import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Config } from "@cbcore/services/config/config.service";
import { CalculationsService } from "@cbcore/services/utils/calculations/calculations.service";
import { UnitsDistributionBase } from './units-distribution.base';
import { find, cloneDeep } from 'lodash-es';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '' // Base component has no template
})
export abstract class RacingUnitsDistributionBase extends UnitsDistributionBase implements OnInit {
  // Common properties
  public competitors!: any[]; // Assigned unconditionally in ngOnInit — pre-existing assumption, not independently verified
  public favorite_selection: any;

  // Optional properties for different racing types
  public silksUrl?: string;
  public bucket?: string;
  public imagesUrl?: string;

  constructor(
    protected _config: Config,
    protected _calculationsService: CalculationsService
  ) {
    super();
  }

  protected initializeUrls(): void {
    // Override in child classes to set specific URLs
  }

  ngOnInit(): void {
    this.initializeUrls();
    this.competitors = cloneDeep(this.leg.sport_event!.sport_event_competitors); // Pre-existing assumption: sport_event is always present for a racing leg, not independently verified
    this.competitors = this._calculationsService.uiUnitDristributionRacingCompetitorsMapping(this.competitors, this.leg);
    this.favorite_selection = find(this.leg.selections, { 'sport_event_competitor_id': null });
  }
}
